export const SHIPMENT_STATUS_BADGE_MAP = {
    to_be_shipped: 'gold',
    pending: 'gold',
    pending_drop_off: 'gold',
    shipped: 'cerulean',
    delivered: 'olive',
    unsorted: 'orange',
    ready_for_pick_up: 'cerulean',
    picked_up: 'cerulean',
    cancelled: 'red',
    delayed: 'orange',
    DEFAULT: 'gold',
}

export const ORDER_PRODUCT_STATUS_BADGE_MAP = {
    cancelled: 'red',
    delayed: 'orange',
    to_be_shipped: 'gold',
    shipped: 'cerulean',
    delivered: 'olive',
    partially_delivered: 'cerulean',
    partially_shipped: 'cerulean',
    unknown: 'red',
    DEFAULT: 'gold',
}

export const VARIANT_STATUS_MAP = {
    ATTENTION_REQUIRED: 'red',
    CANCELLED: 'red',
    BLOCKED: 'red',
    ISSUE_REPORTED: 'gold',
    ISSUE_IN_PROGRESS: 'orange',
    CANCELLATION_REQUESTED: 'gold',
    AWAITING_ORDERCHAMP_APPROVAL: 'gold',
    AWAITING_PAYMENT: 'orange',
    AWAITING_CONFIRMATION: 'cerulean',
    AWAITING_DROP_OFF: 'cerulean',
    AWAITING_FULFILMENT: 'cerulean',
    PARTIALLY_SHIPPED: 'cerulean',
    AWAITING_SHIPMENT: 'cerulean',
    AWAITING_INVOICING: 'cerulean',
    FULFILMENT_IN_PROGRESS: 'gold',
    AWAITING_DELIVERY: 'gold',
    COMPLETED: 'olive',
}

export const FEEDBACK_REASON = {
    has_not_been_confirmed: 'HAS_NOT_BEEN_CONFIRMED',
    has_unresponsive_brand: 'HAS_UNRESPONSIVE_BRAND',
    has_cancellation_reason_objection: 'HAS_CANCELLATION_REASON_OBJECTION',
    has_order_mutations: 'HAS_CANCELLATION_REASON_OBJECTION',
    has_out_of_stock: 'HAS_OUT_OF_STOCK',
    has_damage: 'HAS_DAMAGE',
    has_late_delivery: 'HAS_LATE_DELIVERY',
    has_missing_products: 'HAS_MISSING_PRODUCTS',
    has_wrong_delivery: 'HAS_WRONG_DELIVERY',
    has_invoice_problem: 'HAS_INVOICE_PROBLEM',
    has_product_quality_issue: 'HAS_PRODUCT_QUALITY_ISSUE',
    has_product_information_issue: 'HAS_PRODUCT_INFORMATION_ISSUE',
    has_customer_regret_return: 'HAS_CUSTOMER_REGRET_RETURN',
}

export const REASONS_WITH_REQUIRED_IMAGE = [
    FEEDBACK_REASON.has_damage,
    FEEDBACK_REASON.has_wrong_delivery,
    FEEDBACK_REASON.has_product_quality_issue,
    FEEDBACK_REASON.has_product_information_issue,
]

export const INVOICE_REASON = FEEDBACK_REASON.has_invoice_problem
